import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";

import styles from "../styles/qrCode.module.css";

const downloadQRCode = () => {
    const qrElement = document.getElementById("qr-code");
    if (!qrElement) return;

    html2canvas(qrElement, { scale: 5 }).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png", 1.0);
        link.download = "qr_code.png";
        link.click();
    });
};


const URL = "https://sales.tocahealth.com/videos/";

const QRCodeSales = () => {

    return (
        <div className={styles.page_container}>
            <div className={styles.main_content}>
                <div className={styles.text_center}>
                    <h1 className={styles.main_heading}>Discover Our Healthcare Solutions</h1>
                    <p className={styles.description}>
                        Play video or scan the QR code to watch a demonstration of our Remote Patient Monitoring (RPM)
                        and Chronic Care Management (CCM) services.
                    </p>
                </div>

                <div className={styles.qr_section}>
                    <div className={styles.qr_code_wrapper}>
                        <div className={styles.qr_code_box} id="qr-code">
                            <QRCodeSVG
                                value={URL}
                                size={"100%"}
                                bgColor={"#FFFFFF"}
                                fgColor={"#1E40AF"}
                                level={"H"}
                                includeMargin={false}
                            />
                        </div>
                        <p className={styles.scan_text}>Scan to watch videos</p>
                        {/* <button className={styles.qrButton} onClick={downloadQRCode}>
                            Download QR Code
                        </button> */}
                    </div>
                    <div className={styles.feature_list}>


                        <h2 className={styles.sub_heading}>Transform Your Patient Care</h2>
                        <ul className={styles.list}>
                            <li className={styles.list_item}>
                                <FontAwesomeIcon icon={faCircle} />
                                <p>Remote Patient Monitoring for continuous health tracking</p>
                            </li>
                            <li className={styles.list_item}>
                                <FontAwesomeIcon icon={faCircle} />
                                <p>Chronic Care Management for patients with multiple conditions efvrvervrv rvretvretvbr tvbrtbv r</p>
                            </li>
                            <li className={styles.list_item}>
                                <FontAwesomeIcon icon={faCircle} />
                                <p>Improve patient outcomes with real-time data analysis</p>
                            </li>
                            <li className={styles.list_item}>
                                <FontAwesomeIcon icon={faCircle} />
                                <p>Reduce hospital readmissions and emergency visits</p>
                            </li>
                        </ul>
                        <div className={styles.button_wrapper}>
                            <Link to={'/videos'} >
                                <button>
                                    Watch Videos Now
                                </button>
                            </Link>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default QRCodeSales;
